<template>
  <div 
    class="mt-5">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.filter"
          @keydown.esc="dialog.filter = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Filter Data
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.filter = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <div>
                
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn 
                @click="dialog.filter = false; fetch();"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Filter
              </v-btn>

              <v-btn 
                @click="dialog.filter = false"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Detail Perusahaan

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0" v-if="Object">
              <v-form>
                <v-row>
                  <v-col cols="6">
                    
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.detail = false; dialog.fullscreen = false; ">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="700"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    :name="`Perusahaan`" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div class="mb-2">
                      Perusahaan
                      <span class="red--text">*</span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Perusahaan"

                      hide-details
                      clearable

                      :items="perusahaan"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"
                      class="mb-4"
                      v-model="form.company_id"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <!-- <div v-if="form.company_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div> -->
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                  <ValidationProvider
                    :name="`Jenis Bisnis`" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div class="mb-2">
                      Jenis Bisnis
                      <span class="red--text">*</span>
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pilih Jenis Bisnis"

                      hide-details
                      clearable

                      :items="business_type"
                      item-text="business_type_name"
                      item-value="business_type_name"
                      :item-color="set_color"
                      class="mb-4"
                      v-model="form.business_type"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <!-- <div v-if="form.business_type !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div> -->
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                  <div class="fs-14 mb-1 black_two">
                    Nama Outlet
                    <span class="red--text">*</span>
                  </div>
                  <ValidationProvider 
                    name="Nama Outlet" 
                    rules="required" 
                    v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="save"
                      class="no_box"
                      filled
                      rounded
                      hide-details
                      dense
                      :color="set_color"
                      style="border-radius: 4px;"
                      placeholder="Masukan nama outlet atau unit usaha anda"

                      vv-uppercase

                      v-model="form.name"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <v-row>
                    <v-col cols="12" md="6">
                      <ValidationProvider
                        :name="`Tipe Outlet`" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="mb-2">
                          Tipe Outlet
                          <span class="red--text">*</span>
                        </div>

                        <v-autocomplete
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Tipe Outlet"

                          hide-details
                          clearable

                          :items="[
                            {
                              id: 'trial',
                              name: 'Trial'
                            },
                            {
                              id: 'subscribe',
                              name: 'Subscribe'
                            }
                          ]"
                          item-text="name"
                          item-value="id"
                          :item-color="set_color"
                          v-model="form.outlet_status"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <!-- <div v-if="form.outlet_status !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div> -->
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="12" md="6">
                      <ValidationProvider
                        :name="`Tipe Subcribe`" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="mb-2">
                          Tipe Subcribe
                          <span class="red--text">*</span>
                        </div>

                        <v-autocomplete
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Pilih Tipe Subcribe"

                          hide-details
                          clearable

                          :items="[
                            {
                              id: 'monthly',
                              name: 'Bulanan'
                            },
                            {
                              id: 'annually',
                              name: 'Tahunan'
                            }
                          ]"
                          item-text="name"
                          item-value="id"
                          :item-color="set_color"
                          v-model="form.subscribe_type"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <!-- <div v-if="form.business_type !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div> -->
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <div class="fs-14 mb-1 black_two">
                        Provinsi
                        <span class="red--text">*</span>
                      </div>
                      <ValidationProvider 
                        name="Provinsi" 
                        rules="required" 
                        v-slot="{ errors }">
                        <v-autocomplete
                          v-on:keyup.enter="save"
                          class="no_box"
                          filled
                          rounded
  
                          hide-details
                          dense
                          :items="province"
                          :color="set_color"
                          style="border-radius: 4px;"
                          v-on:change="changeProvince()"
                          item-value="id"
                          item-text="name"
                          placeholder="Pilih provinsi"

                          vv-uppercase

                          v-model="form.province_id"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6">
                      <div class="fs-14 mb-1 black_two">
                        Kota / Kabupaten
                        <span class="red--text">*</span>
                      </div>
                      <ValidationProvider 
                        name="Kota / Kabupaten" 
                        rules="required" 
                        v-slot="{ errors }">
                        <v-autocomplete
                          v-on:keyup.enter="save"
                          v-on:change="changeCity()"
                          item-value="id"
                          item-text="name"
                          class="no_box"
                          filled
                          rounded
  
                          hide-details
                          dense
                          :items="city"
                          :color="set_color"
                          style="border-radius: 4px;"
                          placeholder="Pilih Kota / Kabupaten"

                          vv-uppercase

                          v-model="form.city_id"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6">
                      <div class="fs-14 mb-1 black_two">
                        Kecamatan
                        <span class="red--text">*</span>
                      </div>
                      <ValidationProvider 
                        name="Kecamatan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <v-autocomplete
                          v-on:keyup.enter="save"
                          class="no_box"
                          filled
                          rounded
                          hide-details
                          dense
                          :items="subdistrict"
                          :color="set_color"
                          style="border-radius: 4px;"
                          v-on:change="changeSub()"
                          item-value="id"
                          item-text="name"
                          placeholder="Pilih Kecamatan"

                          vv-uppercase

                          v-model="form.subdistrict_id"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="6">
                      <div class="fs-14 mb-1 black_two">
                        Kelurahan
                        <span class="red--text">*</span>
                      </div>
                      <ValidationProvider 
                        name="Kelurahan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <v-autocomplete
                          v-on:keyup.enter="save"
                          class="no_box"
                          filled
                          rounded
                          hide-details
                          dense
                          :items="village"
                          :color="set_color"
                          style="border-radius: 4px;"
                          v-on:change="changeVal()"
                          item-value="id"
                          item-text="name"
                          placeholder="Pilih Kelurahan"

                          vv-uppercase

                          v-model="form.village_id"
                          :error-messages="errors"
                          required>
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                          </template>
                        </v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <div class="fs-14 mb-1 mt-3 black_two">
                    Alamat Lengkap
                    <span class="red--text">*</span>
                  </div>
                  <ValidationProvider 
                    name="Alamat Lengkap" 
                    rules="required" 
                    v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="save"
                      class="no_box mb-3"
                      filled
                      hide-details
                      dense
                      rounded
                      :color="set_color"
                      style="border-radius: 4px;"
                      placeholder="Masukkan alamat"

                      vv-uppercase

                      v-model="form.address"
                      :error-messages="errors"
                      required>
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <v-row>
                    <v-col
                      cols="12"
                      class="py-0">
                      <label>
                        AutoComplete
                        <gmap-autocomplete
                          placeholder="ketik alamat"
                          class="mb-3"
                          @place_changed="setPlace">
                        </gmap-autocomplete>
                      </label>
                      <!-- <div
                        class="d-flex align-center mb-3">
                        <v-btn
                          v-for="(item, index) in menu"
                          :key="index"

                          @click="selected.menu = item; initMap();"

                          :color="selected.menu === item ? set_color : ''"
                          :class="selected.menu === item ? 'white--text' : ''"
                          :style="selected.menu === item ? 'font-weight: 600;' : ''"

                          small
                          rounded
                          elevation="0"
                          class="text-capitalize mr-4">
                          {{ item }}
                        </v-btn>
                      </div> -->

                      <div v-if="selected.menu === 'Koordinat'">
                        <gmap-map
                          :center="center"
                          :zoom="12"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
                          :clickable="true"
                          @click="updatePlace"
                          style="width: 100%; height: 400px;">

                          <gmap-marker
                            :position="center"
                            :draggable="true"
                            @drag="updatePlace"
                            @click="center = center">
                          </gmap-marker>
                        </gmap-map>
                      </div>

                      <!-- <div v-if="selected.menu === 'Polygon'">
                        <v-card
                          flat
                          min-height="500px"
                          color="transparent"
                          style="border-radius: 10px;">
                          <div 
                            id="map" 
                            style="width: 100%; height: 500px;">
                          </div>
                        </v-card>
                      </div> -->
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pt-6">
                      <ValidationProvider 
                        name="Latitude" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 label-input">
                          <!-- <span class="red--text">*</span> -->

                          Latitude
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
  
                          dense
                          readonly
                          rounded

                          onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                          type="number"
                          min="0"

                          :color="set_color"
                          placeholder="Contoh. -6.1805"

                          v-model="form.latitude"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6"
                      class="pt-6">
                      <ValidationProvider 
                        name="Longitude" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="fs-15 label-input">
                          <!-- <span class="red--text">*</span> -->

                          Longitude
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          readonly

                          onkeypress="return event.charCode >= 45 && event.charCode <= 57"
                          type="number"
                          min="0"

                          :color="set_color"
                          placeholder="Contoh. 106.8284"


                          v-model="form.longitude"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                </v-form>
              </ValidationObserver>

            </v-card-text>
            
            <v-divider 
            class="mt-2"
            style="border-top: 2px dashed #e0e0e0;"/>
            
            <v-card-actions
              class="pa-4">
              <div v-if="message.error.length > 0"
                class="text-left mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <!-- <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="POS Amanata"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Pegawai
                    </span>
                  </div>

                  <v-spacer />

                  <div>
                    <v-btn
                      to="/user/add"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row> -->

          <v-row
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col cols="12" class="pb-2 pt-2">
              <div
                class="d-flex align-center">
                <v-avatar
                  tile
                  size="22">
                  <v-img
                    contain
                    alt="POS Amanata"  
                    :src="require('@/assets/image/grip_menu.png')">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          size="20"
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span
                  class="fs-16 black--text ml-2"
                  style="font-weight: 600;">
                  Outlet
                </span>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="12"
              class="d-flex align-center pb-0">
              <div>
                <v-btn
                  @click="reset(); dialog.form = true;"
                  color="#4B4B4B"
                  elevation="0"
                  small
                  min-height="30"
                  class="fs-12 white--text text-capitalize d-flex align-center"
                  style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                  <v-icon size="18">mdi-plus-circle-multiple</v-icon>
                  
                  <span
                    class="ml-2">
                    Tambah
                  </span>
                </v-btn>
              </div>
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                class="ml-3 fs-12 little-placeholder"
                style="border-radius: 6px; width: 320px; min-width: 320px; max-width: 320px;">
              </v-text-field>

              <!-- FILTER -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.filter = true">
                      <v-icon size="18">mdi-filter-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Filter
                  </span>
                </v-tooltip>
              </div> -->

              <!-- FREEZE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="30"
                      small
                      min-height="30"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div>

              <!-- HIDE COLUMN -->
              <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="30"
                      small
                      min-height="30"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 6px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1 pt-1 pb-0">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '240px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="POS Amanata" 
                            :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="POS Amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="POS Amanata" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              :to="`/outlet/detail/${value}`"
                              
                              v-bind="attrs"
                              v-on="on"
                              
                              min-width="24" min-height="24"
                              x-small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon size="15">mdi-information-slab-circle-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Detail</span>
                        </v-tooltip>
                      </div>

                      <!-- <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        <v-switch
                          @change="toStatus(value, index)"
                          v-model="value"
                          color="success"
                          class="ma-auto"
                          hide-details>
                        </v-switch>
                      </div> -->

                      <div v-if="header.format === 'status'"
                        class="d-flex">
                        {{ value === 'subscribe' ? 'Subscribe' : value === 'trial' ? 'Trial' : value === 'monthly' ? 'Bulanan' : value === 'annually' ? 'Tahunan' : '-' }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination" :display="paginationList"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          delete: false,
          reset: false,
          role: false,

          filter: false,
          form: false
        },
        
        search: '',

        filter: {
          
        },

        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          menu: 'Koordinat'
        },

        role: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},

        lastIndex: 0,
        limit: 20,
        province: [],
        city: [],
        subdistrict: [],
        village: [],
        business_type: [],
        perusahaan: [],

        form: {
          id: '',
          company_id: '',
          name: '',
          business_type: '',
          address: '',
          latitude: '',
          longitude: '',
          province_id: '',
          city_id: '',
          subdistrict_id: '',
          village_id: '',
          province_name: '',
          city_name: '',
          subdistrict_name: '',
          village_name: '',
          outlet_status: '',
          subscribe_type: '',
        },
        map: null,
        center: {
          lat: -6.1805, 
          lng: 106.8284
        },

        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false,
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    mounted () {
      this.fetchType()
      this.fetchPerusahaan()
      this.fetchProv()
    },
    methods: {
      async fetchType() {

         let params = {
          limit: 10000000000000
        }

        await get(`business_type/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.business_type = res.results.data
          }
        })
      },
      async fetchPerusahaan() {

         let params = {
          limit: 10000000000000
        }

        await get(`pos/company/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.perusahaan = res.results.data
          }
        })
      },
      async fetchProv() {

         let params = {
          limit: 10000000000000
        }

        await get(`ref/provinsi`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.province = res.results.data
          }
        })
      },

      changeProvince() {
        this.form.city_id = ''
        this.form.subdistrict_id = ''
        this.form.village_id = ''
        let id = ''
        this.province.map(obj => {
          if (obj.id === this.form.province_id) {
            id = obj.id
            this.form.province = obj.name
          }
        })
        this.fetchCity(id)
      },

      async fetchCity(id) {

         let params = {
          limit: 10000000000000,
          province_id: id
        }

        await get(`ref/kota`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.city = res.results.data
          }
        })
      },

      // async fetchCity(id) {

      //    let params = {
      //     limit: 10000000000000,
      //     province_id: id
      //   }

      //   await get(`ref/kota`, { params })
      //   .then(response => {
      //     let res = response.data
          
      //     if (res.status === 200) {
      //       this.city = res.results.data
      //     }
      //   })
      // },

      changeCity() {
        this.form.subdistrict_id = ''
        this.form.village_id = ''
        let id = ''
        this.city.map(obj => {
          if (obj.id === this.form.city_id) {
            id = obj.id
            this.form.city = obj.name
          }
        })
        this.fetchSub(id)
      },

      async fetchSub(id) {

         let params = {
          limit: 10000000000000,
          city_id: id
        }

        await get(`ref/kecamatan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.subdistrict = res.results.data
          }
        })
      },

      changeSub() {
        this.form.village_id = ''
        let id = ''
        this.subdistrict.map(obj => {
          if (obj.id === this.form.subdistrict_id) {
            id = obj.id
            this.form.subdistrict = obj.name
          }
        })
        this.fetchVil(id)
      },

      async fetchVil(id) {

         let params = {
          limit: 10000000000000,
          subdistrict_id: id
        }

        await get(`ref/kelurahan`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.village = res.results.data
          }
        })
      },

      changeVal() {
        this.village.map(obj => {
          if (obj.id === this.form.village_id) {
            this.form.village = obj.name
          }
        })
      },


      setPlace(place) {
        this.place = place
        this.center = {
          lat: this.place.geometry.location.lat(),
          lng: this.place.geometry.location.lng(),
        
        }
        this.initMap()
        this.form.latitude = this.place.geometry.location.lat()
        this.form.longitude = this.place.geometry.location.lng()
      },

      updatePlace (location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      // INIT MAP
      initMap () {
        let self = this

        this.$gmapApiPromiseLazy().then(() => {
          self.map = new google.maps.Map(document.getElementById('map'), {
            center: { 
              lat: -6.1805, 
              lng: 106.8284
            },
            zoom: 18,
            noClear: true,
            mapTypeId: 'hybrid', //satellite
            navigationControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            tilt: 0
          })

          self.map.data.addListener('addfeature', self.featureAdded)

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_LEFT,
              drawingModes: ['polygon']
            },
            polygonOptions: {
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            }
          })

          drawingManager.setMap(self.map)

          drawingManager.addListener('polygoncomplete', (polygon) => {
            if (polygon.getPath().getLength() < 3) {
              console.log('Polygons must have 3 or more points.')

              polygon.getPath().clear()
            } else {
              // self.form.latlong_json_arr = []

              this.set_polygon_complete = true

              self.addFeature('Polygon', polygon.getPath())

              polygon.setMap(null)
            }
          })

          // #JIKA SINGLE POLYGON
          // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

          // ======================== SPLIT ======================== \\

          // #JIKA MULTI POLYGON
          if (this.form.latlong_json_arr.length > 0) {
            this.form.latlong_json_arr.forEach(obj => {
              self.addFeature('Polygon', obj.latlng)
            })
          }
        })
      },

      featureAdded (e) {
        switch (e.feature.getGeometry().getType()) {
          case 'Polygon':
            addFeature('Polygon', e.feature.getGeometry().getAt(0).getArray())

            break
        }

        self.map.data.remove(e.feature)
      },

      addFeature (type, path) {
        let self = this

        let index_latlng = ''

        switch (type) {
          case 'Polygon':
            let polygon = new google.maps.Polygon({
              fillColor: '#FF0000',
              fillOpacity: 0.35,
              strokeColor: '#FF0000',
              strokeWeight: 2,
              strokeOpacity: 1,
              draggable: true,
              editable: true,
              clickable: true,
              zIndex: 1
            })

            polygon.setPath(path)

            polygon.addListener('click', (e) => {
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.getPath().addListener('insert_at', (e) => {
              // console.log(e)
            })

            polygon.getPath().addListener('set_at', (e, obj) => {
              // self.form.latlong_json_arr[e].lat = obj.lat()
              // self.form.latlong_json_arr[e].lng = obj.lng()

              let polypath = polygon.getPath()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []
              
              for (var i = 0; i < polypath.length; i++) {
                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.getPath().addListener('remove_at', (e) => {
              // console.log(e)
            })

            polygon.addListener('dragstart', (e) => {
              // #JIKA SINGLE POLYGON
              // Konten ketika single polygon

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              let polypath = polygon.getPath()


              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === polypath.getAt(0).lat()) {
                    index_latlng = obj.index
                  }
                })
              })
            })

            polygon.addListener('dragend', (e) => {
              let polypath = polygon.getPath()
              let bounds = new google.maps.LatLngBounds()

              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr = []

              // for (var i = 0; i < polypath.length; i++) {
              //   bounds.extend(polypath.getAt(i))

              //   self.form.latlong_json_arr.push({
              //     lat: polypath.getAt(i).lat(),
              //     lng: polypath.getAt(i).lng()
              //   })
              // }

              // let center = bounds.getCenter()
              // stringlocation = JSON.stringify(self.form.latlong_json_arr)
              // stringcenter = JSON.stringify(center)
              // console.log(stringcenter + stringlocation)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr[index_latlng].latlng = []

              for (var i = 0; i < polypath.length; i++) {
                bounds.extend(polypath.getAt(i))

                self.form.latlong_json_arr[index_latlng].latlng.push({
                  lat: polypath.getAt(i).lat(),
                  lng: polypath.getAt(i).lng()
                })
              }
            })

            polygon.addListener('rightclick', (e) => {
              // #JIKA SINGLE POLYGON
              // if (e.vertex == undefined) return

              // if (polygon.getPath().getLength() === 3) {
              //   polygon.setMap(null)
                
              //   self.form.latlong_json_arr = []
              // } else {
              //   console.log(index_latlng)
              //   polygon.getPath().removeAt(e.vertex)
              //   self.form.latlong_json_arr.splice(e.vertex, 1)
              // }

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              self.form.latlong_json_arr.forEach(obj => {
                obj.latlng.forEach(item => {
                  if(item.lat === e.latLng.lat()) {
                    index_latlng = obj.index
                  }
                })
              })

              if (e.vertex == undefined) return

              if (polygon.getPath().getLength() === 3) {
                polygon.setMap(null)
                
                // self.form.latlong_json_arr = []

                self.form.latlong_json_arr.splice(index_latlng, 1)
              } else {
                polygon.getPath().removeAt(e.vertex)
                self.form.latlong_json_arr[index_latlng].latlng.splice(e.vertex, 1)
              }
            })

            let data_polygon = polygon.getPath()

            let before_insert = []

            for (let i = 0; i < data_polygon.getLength(); i++) {
              // #JIKA SINGLE POLYGON
              // self.form.latlong_json_arr.push({
              //   lat: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[0]),
              //   lng: parseFloat(data_polygon.getAt(i).toUrlValue(10).split(',')[1])
              // })

              // const lats = self.form.latlong_json_arr.map(o => o.lat)
              // self.form.latlong_json_arr = self.form.latlong_json_arr.filter(({lat}, index) => !lats.includes(lat, index + 1))

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              before_insert.push({
                lat: parseFloat(data_polygon.getAt(i).lat()),
                lng: parseFloat(data_polygon.getAt(i).lng())
              })

              const lats = before_insert.map(o => o.lat)
              before_insert = before_insert.filter(({lat}, index) => !lats.includes(lat, index + 1))
            }

            if (before_insert.length > 2 && self.set_polygon_complete) {
              self.form.latlong_json_arr.push({
                index: self.form.latlong_json_arr.length,
                lat: before_insert[0].lat,
                lng: before_insert[0].lng,
                latlng: before_insert
              })

              self.set_polygon_complete = false
            }

            console.log(self.form.latlong_json_arr)

            polygon.setMap(self.map)

            break
        }
      },

      addLatlng () {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.push({
        //   lat: null,
        //   lng: null
        // })

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr.push({
          index: this.form.latlong_json_arr.length,
          latlng: [
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            },
            {
              lat: null,
              lng: null
            }
          ]
        })
      },

      removeLatlng (index) {
        // #JIKA SINGLE POLYGON
        // this.form.latlong_json_arr.splice(index, 1)

        // ======================== SPLIT ======================== \\
        
        // #JIKA MULTI POLYGON
        this.form.latlong_json_arr[index].latlng.splice(index_sub, 1)

        if (this.form.latlong_json_arr[index].latlng.length < 3) {
          this.form.latlong_json_arr.splice(index, 1)
        }

        this.initLatlng()
      },

      initLatlng () {
        let self = this

        if (this.form.latlong_json_arr.length > 2) {
          if (this.form.latlong_json_arr[2].lat !== '' && this.form.latlong_json_arr[2].lat !== null && this.form.latlong_json_arr[2].lng !== '' && this.form.latlong_json_arr[2].lng !== null) {
            this.$gmapApiPromiseLazy().then(() => {
              self.map = new google.maps.Map(document.getElementById('map'), {
                center: { 
                  lat: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lat : -7.7126396311,
                  lng: this.form.latlong_json_arr.length > 0 ? this.form.latlong_json_arr[0].lng : 110.5909243135
                },
                zoom: 18,
                noClear: true,
                mapTypeId: 'hybrid', //satellite
                navigationControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                tilt: 0
              })
    
              self.map.data.addListener('addfeature', self.featureAdded)
    
              const drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: this.form.latlong_json_arr.length < 1 ? google.maps.drawing.OverlayType.POLYGON : null,
                drawingControl: true,
                drawingControlOptions: {
                  position: google.maps.ControlPosition.TOP_LEFT,
                  drawingModes: ['polygon']
                },
                polygonOptions: {
                  fillColor: '#FF0000',
                  fillOpacity: 0.35,
                  strokeColor: '#FF0000',
                  strokeWeight: 2,
                  strokeOpacity: 1,
                  draggable: true,
                  editable: true,
                  clickable: true,
                  zIndex: 1
                }
              })
    
              drawingManager.setMap(self.map)
    
              drawingManager.addListener('polygoncomplete', (polygon) => {
                if (polygon.getPath().getLength() < 3) {
                  console.log('Polygons must have 3 or more points.')
                  polygon.getPath().clear()
                } else {
                  self.addFeature('Polygon', polygon.getPath())
                  polygon.setMap(null)
                }
              })
    
              // #JIKA SINGLE POLYGON
              // if (this.form.latlong_json_arr.length > 0) self.addFeature('Polygon', this.form.latlong_json_arr)

              // ======================== SPLIT ======================== \\

              // #JIKA MULTI POLYGON
              if (this.form.latlong_json_arr.length > 0) {
                this.form.latlong_json_arr.forEach(obj => {
                  self.addFeature('Polygon', obj.latlng)
                })
              }
            })
          }
        } else {
          this.initMap()
        }
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search
        }

        this.selected.row = []

        await get(`pos/outlet/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                // width: '80px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Outlet',
                width: '300px',
                value: 'name',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Perusahaan',
                width: '200px',
                value: 'company_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Alamat',
                width: '200px',
                value: 'address',
                freeze: false,
                hide: false
              },
              {
                text: 'Status',
                width: '150px',
                value: 'status',
                freeze: false,
                hide: false,
                format: 'status'
              },
              {
                text: 'Type Subscribe',
                width: '150px',
                value: 'subscribe_type',
                freeze: false,
                hide: false,
                format: 'status'
              },
              {
                text: 'Tanggal Mulai trial',
                width: '200px',
                value: 'trial_start_date',
                freeze: false,
                hide: false,
                format: 'datetime'
              },
              {
                text: 'Tanggal Berakhir trial',
                width: '200px',
                value: 'trial_end_date',
                freeze: false,
                hide: false,
                format: 'datetime'
              }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination


            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          company_id: index !== undefined ? this.list[index].company_id : '',
          name: index !== undefined ? this.list[index].name : '',
          business_type: index !== undefined ? this.list[index].business_type : '',
          address: index !== undefined ? this.list[index].address : '',
          latitude: index !== undefined ? this.list[index].latitude : '',
          longitude: index !== undefined ? this.list[index].longitude : '',
          province_id: index !== undefined ? this.list[index].province_id : '',
          city_id: index !== undefined ? this.list[index].city_id : '',
          subdistrict_id: index !== undefined ? this.list[index].subdistrict_id : '',
          village_id: index !== undefined ? this.list[index].village_id : '',
          province_name: index !== undefined ? this.list[index].province_name : '',
          city_name: index !== undefined ? this.list[index].city_name : '',
          subdistrict_name: index !== undefined ? this.list[index].subdistrict_name : '',
          outlet_status: index !== undefined ? this.list[index].outlet_status : '',
          subscribe_type: index !== undefined ? this.list[index].subscribe_type : '',
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''
        
        const isValid = this.$refs.form.validate()
        
        if (isValid) {
          this.process.form = true
          
          let url = 'pos/outlet/add'
          // console.log(url)

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              if (this.form.id === '') {
                this.fetch()
              } else {
                this.fetch(this.paginationList)
              }
              this.reset()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/user/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

    }
  }
</script>

<style>
 .pac-target-input {
  width: 100% !important;
  padding: 8px !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
  background: rgba(0, 0, 0, 0.06);
 }
</style>